import type { ProjectSummary, SessionSummary } from "../types";

/** Whether `me` can file this conversation under a project: their own, opened by a person, not anonymous, under none yet. */
export function canFile(session: SessionSummary, me: string): boolean {
	return session.owner === me && session.createdBy === "user" && !session.anonymous && session.projectId === null;
}

/** The projects this conversation can be filed under; none when it cannot be filed. */
export function filingTargets(session: SessionSummary, me: string, projects: readonly ProjectSummary[]): ProjectSummary[] {
	if (!canFile(session, me)) return [];
	return projects.filter((p) => p.profile === session.profile && p.owner === me && !p.archived);
}
